export default __webpack_public_path__ + "static/media/auto-regularize-outline-16px.6cf82dba.svg";